module.exports = __webpack_public_path__ + "static/media/view1.6479cb3f.jpg";